<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-07-31 13:24:05
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2023-07-31 13:38:12
 * @FilePath: /wemeet-poster/Users/hvv/weMeetSpace/WeMeet_admin_project/wemeet-admin/src/components/qrCodePreview/index.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-dialog v-model="dialogFormVisible" :title="title" width="520px" @close="handleClose">
    <el-divider content-position="center" />
    <el-image :fit="fit" :src="url" style="width: 100%; min-height: 400px" />
    <el-divider content-position="center" />
    <p>H5地址: {{ website }}</p>
    <el-button class="mt-20 w-percent-100" size="large" type="primary" @click="handleClose">关闭</el-button>
  </el-dialog>
</template>
<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, toRefs } from 'vue'
  export default defineComponent({
    name: 'Index',
    props: {
      title: {
        type: String,
        default: '预览',
      },
      url: {
        type: String,
        default: '',
      },
      website: {
        type: String,
        default: '',
      },
    },
    emits: ['fetch-data'],
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance()

      const state = reactive({
        dialogFormVisible: false,
        list: [],
        fit: 'cover',
      })

      const handleClose = () => {
        state.dialogFormVisible = false
      }
      const handleOpen = () => {
        state.dialogFormVisible = true
      }
      return {
        ...toRefs(state),
        handleOpen,
        handleClose,
      }
    },
  })
</script>
